import { render, staticRenderFns } from "./SponsorPackage.vue?vue&type=template&id=73f65a4e&scoped=true&"
import script from "./SponsorPackage.vue?vue&type=script&lang=js&"
export * from "./SponsorPackage.vue?vue&type=script&lang=js&"
import style0 from "./SponsorPackage.vue?vue&type=style&index=0&id=73f65a4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f65a4e",
  null
  
)

export default component.exports